import { render, staticRenderFns } from "./r-discovery-page.vue?vue&type=template&id=df32fabe"
import script from "./r-discovery-page.vue?vue&type=script&lang=js"
export * from "./r-discovery-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df32fabe')) {
      api.createRecord('df32fabe', component.options)
    } else {
      api.reload('df32fabe', component.options)
    }
    module.hot.accept("./r-discovery-page.vue?vue&type=template&id=df32fabe", function () {
      api.rerender('df32fabe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/discovery/r-discovery-page.vue"
export default component.exports